import React from "react";

const About = () => {
  return (
    <div className="about_us">
      <div className="container about_us_main">
        <div className="about_us_img">
          <img src="/img/about.webp" alt="about img" />
        </div>
        <div className="about_us_content">
          <h1 className="dc-script">Fresh Food, Simply Deliciuos</h1>
          <p className="dm-sans">
            Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
            posuere cubilia Curae; Maecenas venenatis posuere volutpat. Mauris
            laore Sed non sem blandit, ultrices nisl et, auctor purus. Nunc quam
            diam, vehicula in metus quis, pulvinar finibus tortor
          </p>
          <button className="flex-center">
            <i className="bi bi-play-fill"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
